import { RocCountyInfo,  RocZipcode } from "@/models/HELPERS/utilitiesData.js";

// export default {
//     /**
//      * 事件防抖與節流
//      * @param {Function} func 函式
//      * @param {Number} wait 每幾毫秒，請求一次服務器
//      * @return {Function}
//      */
//     debounce(func, wait = 500) {
//         let timeout;

//         return function(event) {
//           clearTimeout(timeout);

//           timeout = setTimeout(() => {
//             func.call(this, event);
//           },wait);
//         }
//     },

//     /**
//      * 檢查字串是否為數字
//      * @param {String} val 傳入檢查值
//      * @return {Boolean}
//      */
//     isNum(val) {
//         return !isNaN(val)
//     },

//     /**
//      * 計算欄位"序"的數字
//      * @param {Object.<string, string>} page_data 傳入檢查表格資料
//      * @param {Number} index // 第幾個陣列
//      * @return {Number}
//      */
//     countNoNum(page_data = {}, index = 0) {
//         return page_data.pageSize * page_data.pageIndex - page_data.pageSize + index + 1;
//     },

//     /**
//      * 轉換民國日期
//      * @param {String} date // 日期
//      * @return {String}
//      */
//     const convertRocDate = (date = null) => {
//       if (!date) return;

//       const inputDate = new Date(date);
//       const twYear = inputDate.getFullYear() - 1911;
//       const twMonth = String(inputDate.getMonth() + 1).padStart(2, '0');
//       const twDay =  String(inputDate.getDate()).padStart(2, '0');
//       const twDateStr = `${twYear}-${twMonth}-${twDay}`;

//       return twDateStr;
//     }
// }

/**
 * 計算欄位"序"的數字
 * @param {Object.<string, string>} page_data 傳入檢查表格資料
 * @param {Number} index // 第幾個陣列
 * @return {Number}
 */
export const countNoNum = (page_data = {}, index = 0) => {
  return page_data.pageSize * page_data.pageIndex - page_data.pageSize + index + 1;
}

/**
 * 取得今天日期
 * @param {Boolean} is_roc // 是否為民國日期
 * @param {Boolean} split_date // 回傳是否把年月日拆開
 * @return {String}
 */
export const getTodayDate = (is_roc = false, split_date = false) => {
  const today = new Date();
  let year = '';

  if (is_roc) year = String(today.getFullYear() - 1911).padStart(3, '0');
  else  year = String(today.getFullYear()).padStart(4, '0');

  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day =  String(today.getDate()).padStart(2, '0');

  return split_date ? {year: year, month: month, day: day} : `${year}-${month}-${day}`;
}

/**
 * 取得該月的第一天和最後一天(沒傳date，則取得當月)
 * @param {Date || String} date // 日期
 * @param {Boolean} is_time // 是否要有時間
 * @return {Object}
 */
export const getFirstAndLastDayOfMonth = (date = null, is_time = false, is_roc = false) => {
  let inputDate = '';

  if (typeof date === 'string') {
    inputDate = date ? new Date(date.replace(/-/g, '/')) : new Date();
  } else {
    inputDate = date ? date : new Date();
  }

  const first_day = new Date(inputDate.getFullYear(), inputDate.getMonth(), 1);
  const last_day = new Date(inputDate.getFullYear(), inputDate.getMonth() + 1, 0);

  const convertDate = (date) => {
    const year = is_roc ? String(date.getFullYear() + 1911) : String(date.getFullYear());
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day =  String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  let callback_first_day = convertDate(first_day), callback_last_day = convertDate(last_day);

  if (is_time) {
    callback_first_day = `${convertDate(first_day)} 00:00:00`;
    callback_last_day = `${convertDate(last_day)} 23:59:59`
  }


  return {
    first_day: callback_first_day,
    last_day: callback_last_day
  }
}

/**
 * 取得年和月組合的期別(沒傳date，則取得當月)，組合的年使用民國
 * @param {Date || String} date // 日期
 * @return {Object}
 */
export const getRocYearAndMonthOfPeriod = (date = null) => {
  let inputDate = '';

  if (typeof date === 'string') {
    inputDate = date ? new Date(date.replace(/-/g, '/')) : new Date();
  } else {
    inputDate = date ? date : new Date();
  }

  const twYear = String(inputDate.getFullYear() - 1911).padStart(3, '0');
  const twMonth = String(inputDate.getMonth() + 1).padStart(2, '0');

  return `${twYear}${twMonth}`;
}

/**
 * 轉換民國日期
 * @param {Date || String} date // 日期
 * @param {Boolean} keep_time // 是否保留時間
 * @param {Boolean} split_date // 回傳是否把年月日拆開
 * @return {String}
 */
export const convertRocDate = (date = null, keep_time = true, split_date = false) => {
  let inputDate = '';

  if (typeof date === 'string') {
    if (!date || date.includes('0000')) return;

    inputDate = date ? new Date(date.replace(/-/g, '/')) : new Date(); // 修改日期格式為支援的格式（替換所有 '-' 為 '/'）
  } else {
    if (!date) return;

    inputDate = date ? date : new Date();
  }

  if (isNaN(inputDate)) return; // 檢查日期是否為有效日期

  const twYear = String(inputDate.getFullYear() - 1911).padStart(3, '0');
  const twMonth = String(inputDate.getMonth() + 1).padStart(2, '0');
  const twDay =  String(inputDate.getDate()).padStart(2, '0');
  let twTime = '';

  if (keep_time && date.includes(':')) {
    const hours = String(inputDate.getHours()).padStart(2, '0');
    const minutes = String(inputDate.getMinutes()).padStart(2, '0');
    const seconds = String(inputDate.getSeconds()).padStart(2, '0');
    twTime = ` ${hours}:${minutes}:${seconds}`;
  }

  const twDateStr = `${twYear}-${twMonth}-${twDay}${twTime}`;

  return split_date ? {year: twYear, month: twMonth, day: twDay} : twDateStr;
}

/**
 * 日期格式轉換
 * @param {Date || String} date // 日期
 * @param {Boolean} keep_time // 是否保留時間
 * @param {Boolean} split_date // 回傳是否把年月日拆開
 * @return {String}
 */
export const convertDateFormat = (date = null, keep_time = true, split_date = false) => {
  let inputDate = '';

  if (typeof date === 'string') {
    if (!date || date.includes('0000')) return;

    inputDate = date ? new Date(date.replace(/-/g, '/')) : new Date(); // 修改日期格式為支援的格式（替換所有 '-' 為 '/'）
  } else {
    if (!date) return;

    inputDate = date ? date : new Date();
  }

  if (isNaN(inputDate)) return; // 檢查日期是否為有效日期

  const year = String(inputDate.getFullYear()).padStart(4, '0');
  const month = String(inputDate.getMonth() + 1).padStart(2, '0');
  const day =  String(inputDate.getDate()).padStart(2, '0');
  let time = '';

  if (keep_time && date.includes(':')) {
    const hours = String(inputDate.getHours()).padStart(2, '0');
    const minutes = String(inputDate.getMinutes()).padStart(2, '0');
    const seconds = String(inputDate.getSeconds()).padStart(2, '0');
    time = ` ${hours}:${minutes}:${seconds}`;
  }

  const dateStr = `${year}-${month}-${day}${time}`;

  return split_date ? {year: year, month: month, day: day} : dateStr;
}

/**
 * 取得使用者localStorage 資料
 * @param {Number} authority 使用者身份(1 = 總後台, 2 = 要助人, 3 = 業務)
 * @return {Number}
 */
export const getLocalUserInfo = (authority = 1) => {
  let info = '';

  if (authority === 1) info = JSON.parse(window.localStorage.getItem('yfInfo')) || null;
  else if (authority === 2) info = JSON.parse(window.localStorage.getItem('toHelpingOthersInfo')) || null;
  else if (authority === 3) info = JSON.parse(window.localStorage.getItem('businessInfo')) || null;

  return info;
}

/**
 * 設定使用者localStorage 資料
 * @param {Number} authority 使用者身份(1 = 總後台, 2 = 要助人, 3 = 業務)
 * @param {Object} data 存入資料
 * @return {Number}
 */
export const setLocalUserInfo = (authority = 1, data = {}) => {
  if (authority === 1) window.localStorage.setItem('yfInfo', JSON.stringify(data));
  else if (authority === 2) window.localStorage.setItem('toHelpingOthersInfo', JSON.stringify(data));
  else if (authority === 3) window.localStorage.setItem('businessInfo', JSON.stringify(data));
}

/**
 * 移除使用者localStorage 資料
 * @param {Number} authority 使用者身份(1 = 總後台, 2 = 要助人, 3 = 業務)
 * @return {Number}
 */
export const removeLocalUserInfo = (authority = 1) => {
  if (authority === 1) window.localStorage.removeItem('yfInfo');
  else if (authority === 2) window.localStorage.removeItem('toHelpingOthersInfo');
  else if (authority === 3) window.localStorage.removeItem('businessInfo');
}

/**
 * 檢查上傳檔案，是否符合上傳限制
 * @param {Object.<string, string>} file 檔案資料
 * @param {String} file_accept 限制檔案類型
 * @param {Nember} limit_mb 檔案大小
 * @return {Boolean}
 */
export const checkUpdateFile = (file, file_accept = '', limit_mb = 20) => {
  const file_ext = file.name.split(".").pop(); // 副檔名
  const file_size_mb = file.size / (1024*1024);

  // 檔案類型 & 大小限制
  if ((file_accept && !file_accept.includes(file_ext)) || file_size_mb > limit_mb) return false;
  else return true;
}

/**
 * 檢查是否符合年齡限制
 * @param {String} birthday 生日
 * @param {String} ageLimit 年齡限制
 * @return {Boolean}
 */
export const checkAgeLimit = (birthday, ageLimit = 18) => {
  // 取得今天的日期
  const today = new Date();

  // 將使用者生日轉換為日期物件
  const userBirthday = new Date(birthday);

  // 計算使用者年齡
  let userAge = today.getFullYear() - userBirthday.getFullYear();

  // 檢查是否已過生日，如果還未過，年齡減一
  if (today.getMonth() < userBirthday.getMonth() ||
      (today.getMonth() === userBirthday.getMonth() && today.getDate() < userBirthday.getDate())) {
    userAge--;
  }

  return userAge >= ageLimit;

  // 檢查使用者年齡是否符合年齡限制
  if (userAge >= ageLimit) {
    return true; // 符合年齡限制
  } else {
    return false; // 不符合年齡限制
  }
}

/**
 * 檢查身份證格式是否符合
 * @param {String} id 身份證字號
 * @return {Boolean}
 */
// export const validateTWID = (id) => {
//   if (!id) return false

//   // 依照字母的編號排列，存入陣列備用。
//   const letters = new Array('A', 'B', 'C', 'D',
//     'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M',
//     'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V',
//     'X', 'Y', 'W', 'Z', 'I', 'O');
//   // 儲存各個乘數
//   const multiply = new Array(1, 9, 8, 7, 6, 5, 4, 3, 2, 1);
//   let nums = new Array(2);
//   let firstChar;
//   let firstNum;
//   let lastNum;
//   let total = 0;

//   // 撰寫「正規表達式」。第一個字為英文字母，
//   // 第二個字為1或2，後面跟著8個數字，不分大小寫。
//   const regExpID=/^[a-z](1|2)\d{8}$/i;

//   // 使用「正規表達式」檢驗格式
//   if (id.search(regExpID) == -1) {
//     // 基本格式錯誤
// 	  // alert("請仔細填寫身份證號碼");
//     return false;
//   } else {
//     // 取出第一個字元和最後一個數字。
//     firstChar = id.charAt(0).toUpperCase();
//     lastNum = id.charAt(9);
//   }

//   // 找出第一個字母對應的數字，並轉換成兩位數數字。
//   for (var i=0; i<26; i++) {
//     if (firstChar == letters[i]) {
//       firstNum = i + 10;
//       nums[0] = Math.floor(firstNum / 10);
//       nums[1] = firstNum - (nums[0] * 10);
//       break;
//     }
//   }

//   // 執行加總計算
//   for (var i=0; i<multiply.length; i++) {
//     if (i<2) {
//       total += nums[i] * multiply[i];
//     } else {
//       total += parseInt(id.charAt(i-1)) * multiply[i];
//     }
//   }

//   // 和最後一個數字比對
//   if ((10 - (total % 10))!= lastNum) {
//     // alert("身份證號碼寫錯了！");
//     return false;
//   }

//   return true;
// }

export const validateTWID = (id) => {
  if (!id) return false;

  id = id.trim();

  // 在 js 中遇到反斜線要跳脫，所以這邊用兩個反斜線
  // 如果你看到四個反斜線，那是我為了讓 NexT.Mist 主題順利渲染所再做跳脫
  const  verification = id.match("^[A-Z][12]\\d{8}$")
	if(!verification){
		return false
	}

  let conver = "ABCDEFGHJKLMNPQRSTUVXYWZIO"
  let weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]

  id = String(conver.indexOf(id[0]) + 10) + id.slice(1);

  let checkSum = 0
  for (let i = 0; i < id.length; i++) {
      const c = parseInt(id[i])
      const w = weights[i]
      checkSum += c * w
  }

  return checkSum % 10 == 0
}

/**
 * 使用身份證取得性別
 * @param {String} id 身份證字號
 * @return {Boolean} 2 為女性，1 為男性
 */
export const getGender = (id = '') => {
  if (!id) return '';

  // 根據身份證號的第二位數字來判斷性別
  const secondDigit = parseInt(id.charAt(1), 10);

  if (!validateTWID) {
    return "無效的身份證號碼";
  } else {
    // 2 為女性，1 為男性
    return secondDigit % 2 === 0 ? "女" : "男";
  }
}

/**
 * 下載檔案
 * @param {Object.<string, string>} response
 */
export const downloadFile = (response = {}) => {
  const file = getHeaderFileContent(response.headers);
  const link = document.createElement("a");
  let header_set = "content-type";

  if (file.ext === 'xlsx' || file.ext === 'xls') {
    header_set = "application/vnd.ms-excel";
  }

  if (file.ext === 'csv' || file.ext === 'zip') {
      header_set = "application/octet-stream";
  }

  if (file.ext !== 'json') {
      const blob = new Blob([response.data], {
          type: response.headers[header_set]
      });

      if (file.ext === 'zip') {
          saveAs(blob, `${file.fileName}.${file.ext}`);
      } else {
          link.href = window.URL.createObjectURL(blob);
          link.download = `${file.fileName}.${file.ext}`;
          link.click();
      }


  } else {
      const headers_data = "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(response.data));

      link.href = 'data:' + headers_data;
      link.download = `${file.fileName}.${file.ext}`;
      link.click();
  }
}

/**
 * 取得標頭的檔案內容(檔名、副檔名)
 * @param {Object.<string, string>} headers
 * @return {Object}
 */
export const getHeaderFileContent = (headers) => {
  const disposition = headers['content-disposition'];
  const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-\.]+)(?:; ?|$)/i;
  const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;
  let file = '';

  if (utf8FilenameRegex.test(disposition)) {
      file = decodeURIComponent(utf8FilenameRegex.exec(disposition)[1]);
  } else {
      const filenameStart = disposition.toLowerCase().indexOf('filename=');
      if (filenameStart >= 0) {
          const partialDisposition = disposition.slice(filenameStart);
          const matches = asciiFilenameRegex.exec(partialDisposition );
          if (matches != null && matches[2]) {
              file = matches[2];
          }
      }
  }

  const [ext, file_name] = file.split('.').reverse();

  return {
      fileName: file_name,
      ext: ext
  };
}

/**
 * 計算表格一整排總計
 * @param {Array} data 計算資料
 * @param {String} key 要計算的值
 * @return {Number}
 */
export const calculateRowsSum = (data = [], key = '') => {
  if (data.length === 0 || !key) return 0;

  return data.reduce((accumulator, currentValue) => {
    return accumulator + Number(currentValue[key])
  }, 0);
}

/**
 * 取得帳單領取方式文字
 * @param {Number} receive 帳單領取方式變數
 * @return {String}
 */
export const getBillReceiveMethodText = (receive) => {
  let text = '';

  switch (receive) {
    case 0:
      text = '郵寄';
      break;
    case 1:
      text = '通知業務';
      break;
    case 2:
      text = '自取';
      break;
    case 3:
      text = '萬事達-郵寄';
      break;
    case 4:
      text = '萬事達-自取';
      break;
    case 5:
      text = '萬事達-特殊';
      break;
    case 6:
      text = '自動扣款';
      break;
    case 7:
      text = '墊繳';
      break;
    case 8:
      text = '特殊';
      break;
    case 9:
      text = '不印帳單';
      break;
    case 10:
      text = '萬事達-不印帳單';
      break;
    default:
      text = '郵寄';
  }

  return text;
}

/**
 * 取得台灣郵遞區號
 * @param {String} address 地址
 * @return {String}
 */
export const getRocZipcode = (address) => {
  try {
    const county = RocCountyInfo.find(item => address.includes(item));

    for (const [key, value] of Object.entries(RocZipcode[county])) {

      const search_status = address.includes(key);

      if (search_status) return value;
    }

  } catch (e) {
    return '';
  }
}

/**
 * 遮蔽資料
 * @param {String} data 資料
 * @param {String} type 類型(姓名 OR 身分證)
 * @return {String}
 */
export const maskData = (data, type) => {
  if (type === 'name') {
    // 如果是姓名
    if (data.length === 2) {
      // 名字長度為2，只保留第一個字，後面用星號代替
      const firstChar = data.charAt(0);
      const restMask = '*'.repeat(Math.max(0, data.length - 1));
      return firstChar + restMask;
    } else {
      // 名字長度不為2，保留最前面和最後面的字，中間用星號代替
      const firstChar = data.charAt(0);
      const lastChar = data.charAt(data.length - 1);
      const middleMask = '*'.repeat(Math.max(0, data.length - 2));
      return firstChar + middleMask + lastChar;
    }
  } else if (type === 'ID') {
    // 如果是身分證，保留前6位，後4位用星號代替
    const firstSixChars = data.slice(0, 6);
    const lastFourMask = '*'.repeat(Math.max(0, data.length - 6));
    return firstSixChars + lastFourMask;
  } else {
    // 如果 type 不是姓名或身分證，返回原始數據
    return data;
  }
}

/**
 * 取得帳單類型文字顏色
 * @param {String} type 帳單類型
 * @return {String}
 */
export const getBillTypeColor = (type) => {
  let type_class = 'text-primary';

  switch (type) {
    case 'M':
      type_class = 'text-primary';
      break;
    case 'Y':
      type_class = 'text-secondary';
      break;
    case 'F':
      type_class = 'text-success';
      break;
    case 'S':
      type_class =  'text-info';
      break;
    case 'B':
      type_class = 'text-warning';
      break;
    default:
      type_class = 'text-primary';
  }

  return type_class;
}

/**
 * 取得帳單費用說明
 * @param {Object} details 帳單細項
 * @return {String}
 */
export const getBillFeeDescription = (details = {}, is_simply = false) => {
  const {type, promotion_name, promotion_times, promotion_times_total} = details;
  const s_text = !is_simply ? promotion_times_total ? `${promotion_name}${promotion_times_total}期-${promotion_times}` : promotion_name : '回饋金';
  let text = '';

  switch (type) {
    case 'M':
      text = '互助費';
      break;
    case 'Y':
      text = '平台年費';
      break;
    case 'F':
      text = '上期手續費';
      break;
    case 'S':
      text = s_text;
      break;
    case 'B':
      text = '墊繳手續費';
      break;
    default:
      text = '互助費';
  }

  return text;
}

/**
 * 數字加上逗號，保留小數點
 * @param {Number} _Value 傳入值
 * @param {Number} decimalPlaces 保留小數幾位(等於 -1，則保留所有小數位)
 * @returns {String} 返回整數部分和小數部分
 */
export const Thousands = (_Value, decimalPlaces = -1) => {
	let num = '0';

	// 如果沒有值，返回 0,根據decimalPlaces數量去增加小數點
	if (!_Value) {
		for (let i = 0; i < decimalPlaces; i++) {
			if (i === 0) num += '.0';
			else num += '0';
		}

		return num;
	}

	const parts = _Value.toString().split('.'); // 拆分整數部分和小數部分
	const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); // 轉換整數部分

	let decimalPart = '';
	if (decimalPlaces === -1) {
		// 如果 decimalPlaces 等於 -1，則保留所有小數位
		decimalPart = parts[1] ? `.${parts[1]}` : '';
	} else if (decimalPlaces > 0) {
		// 如果 decimalPlaces 大於 0，則保留指定的小數位數
		decimalPart = `.${parts[1] || ''}`.padEnd(decimalPlaces + 1, '0').substring(0, decimalPlaces + 1);
	} else if (decimalPlaces === 0) {
		// 如果 decimalPlaces 等於 0，則不保留小數位
		decimalPart = '';
	}

	return `${integerPart}${decimalPart}`;
}

/**
 * 帶入年齡計算日期範圍
 * @param {Number} age_start 年齡開始
 * @param {Number} age_end 年齡結束
 * @returns {Object} 返回日期開始與結束
 */
export const calculateDateRange = (age_start = null, age_end = null) => {
  let start_date = '', end_date = '';
  const currentDate = new Date(); // 獲取當前日期
  const currentYear = currentDate.getFullYear(); // 獲取當前年份

  // 如果 age_start 或 age_end 為 null 或空值，直接返回空值
  if (age_start) {
    // 計算年輕年齡對應的最近日期，也就是年齡開始的日期
    const date = new Date(new Date().setFullYear(currentYear - age_start));

    end_date = date.toISOString().split('T')[0];     // 將日期格式化為 'YYYY-MM-DD'
  }

  if (age_end) {
    // 計算較老年齡對應的最早日期，也就是年齡結束的日期
    const date = new Date(new Date().setFullYear(currentYear - age_end - 1));

    date.setDate(date.getDate() + 1); // 加一天以包含年齡的起始日
    start_date = date.toISOString().split('T')[0]; // 將日期格式化為 'YYYY-MM-DD'
  }

  return {
    startDate: start_date,
    endDate: end_date
  };
}

/**
 * 帶入出生日期計算年齡
 * @param {String} birthdate 出生日期
 * @returns {Number} 返回年齡
 */
export const calculateAge = (birthdate) => {
  const today = new Date();
  const birthDate = new Date(birthdate);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

/**
 * 判斷數值NaN，如果是 NaN 則返回 0，否則返回原始值
 * @param {Number} value 傳入值
 * @returns {Number}
 */
export const handleNaN = (value) => {
  return isNaN(value) ? 0 : value
};

/**
 * 判斷是否為閏年
 * @param {Number} yyyy 西元年
 * @returns {Boolean}
 */
export const isLeapYear = (yyyy) => {
  const format_yyyy = Number(yyyy);

  return (format_yyyy % 4 == 0 && format_yyyy % 100 != 0) || (format_yyyy % 400 == 0) ? true : false;
};

/**
 * 設置權限(routes、menu)
 * @param {Array} data 需要設定權限資料
 * @param {Object} permission 權限
 * @param {String} parent_tag 父層 權限tag
 */
export const setPermission = (data = [], permission = {}, parent_tag = '') => {
  data.forEach((item, i) => {
    const permission_key = item.meta.parent_tag || parent_tag || item.meta.permission_tag[0];
    const permission_value = JSON.parse(permission[permission_key]);

    item.meta.permission = [];

    // 判斷權限 permission_value 是否為物件
    if (typeof permission_value === 'object' && permission_value !== null) {
      if (permission_value['search'] && permission_value['search'].some(el => item.meta.permission_tag.includes(el))) {
        item.meta.permission.push('search');
      }

      if (permission_value['update'] && permission_value['update'].some(el => item.meta.permission_tag.includes(el))) {
        item.meta.permission.push('update');
      }
    }

    if (item.children && item.children.length > 0) {
      setPermission(item.children, permission, item.meta.permission_tag[0]);
    }
  })
}

/**
 * 判斷是否有編輯權限
 * @param {Object} meta 路由相關資訊
 * @param {Object} permission 權限
 * @returns {Boolean}
 */
export const isUpdatePermission = (meta, permission) => {
  if (!meta.parent_tag) return false

  const permission_value = JSON.parse(permission[meta.parent_tag]);

  return permission_value['update'].some(el => meta.permission_tag.includes(el))
}

/**
 * 取得權益文字
 * @param {status} meta 權益狀態
 * @returns {Object}
 */
export const getRightsInterests  = (status = 0) => {
  let text = '', bg_class = '';

  switch (status) {
    case 0:
      text = '正常';
      bg_class = 'bg-normal';
      break;
    case 1:
      text = '身故';
      bg_class = 'bg-died';
      break;
    case 2:
      text = '停效';
      bg_class = 'bg-stop';
      break;
    case 3:
      text = '除會';
      bg_class = 'bg-fail';
      break;
    case 4:
      text = '墊繳';
      bg_class = 'bg-close';
      break;
  }

  return { text, bg_class };
}



// WEBPACK FOOTER //
// ./src/models/HELPERS/common.js